import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaDownload, FaPlay, FaPause, FaChevronRight, FaChevronLeft } from "react-icons/fa";

const HRPage = () => {
  const [data, setData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [playingStates, setPlayingStates] = useState({});

  useEffect(() => {
    axios
      .get("https://api.theleadsense.com/api/v1/student-data")
      .then((res) => {
        if (res.data.status === 200) {
          setData(res.data.data.users_details);
        }
      })
      .catch(console.error);
  }, []);

  const togglePlay = (index) => {
    const videoEl = document.getElementById(`video-${index}`);
    if (!videoEl) return;

    if (videoEl.paused) {
      videoEl.play();
      setPlayingStates((prev) => ({ ...prev, [index]: true }));
    } else {
      videoEl.pause();
      setPlayingStates((prev) => ({ ...prev, [index]: false }));
    }
  };

  const handleVideoPlay = (index) => {
    setPlayingStates((prev) => ({ ...prev, [index]: true }));
  };

  const handleVideoPause = (index) => {
    setPlayingStates((prev) => ({ ...prev, [index]: false }));
  };

  // Go to next user
  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % data.length);
  };

  // Go to previous user
  const goPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + data.length) % data.length);
  };

  if (data.length === 0) {
    return (
      <div className="hr-container">
        <p>Loading data...</p>
      </div>
    );
  }

  const user = data[currentIndex];

  return (
    <div className="hr-containers">
      <div className="carousel-wrapper">
        <button className="nav-btn prev-btn" onClick={goPrev} aria-label="Previous">
          <FaChevronLeft size={24} />
        </button>

        <div className="card horizontal-card">
          <div className="video-section">
            {user.video_url ? (
              <div
                className="video-wrapper"
                onClick={() => togglePlay(currentIndex)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") togglePlay(currentIndex);
                }}
              >
                <video
                  id={`video-${currentIndex}`}
                  src={user.video_url}
                  loop
                  autoPlay
                  playsInline
                  onPlay={() => handleVideoPlay(currentIndex)}
                  onPause={() => handleVideoPause(currentIndex)}
                  className="reel-video"
                />

                <div
                  className={`play-pause-overlay ${playingStates[currentIndex] ? "hidden" : ""
                    }`}
                >
                  <FaPlay size={48} color="white" />
                </div>
              </div>
            ) : (
              <div className="no-video">No Video Available</div>
            )}
          </div>

          <div className="card-content">
            <h2 className="name">{user.name || "N/A"}</h2>
            <p className="email">{user.email || "N/A"}</p>

            {user.cv_url ? (
              <a
                href={user.cv_url}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="cv-btn"
                title="Download CV"
              >
                <FaDownload style={{ marginRight: "8px" }} />
                Download CV
              </a>
            ) : (
              <p className="no-cv">CV Not Available</p>
            )}
          </div>
        </div>

        <button className="nav-btn next-btn" onClick={goNext} aria-label="Next">
          <FaChevronRight size={24} />
        </button>
      </div>

      <style>{`
        .hr-container {
          padding: 40px 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background-color: #f9fafb;
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .carousel-wrapper {
          display: flex;
          align-items: center;
          gap: 16px;
          max-width: 900px;
          width: 100%;
        }

        .nav-btn {
          background-color: #2563eb;
          border: none;
          color: white;
          padding: 12px;
          border-radius: 50%;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.5);
          transition: background-color 0.25s ease, transform 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          user-select: none;
        }

        .nav-btn:hover {
          background-color: #1e40af;
          transform: scale(1.1);
        }

        .card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          cursor: default;
          display: flex;
          flex-direction: row;
          height: 480px;
          flex: 1 1 auto;
        }

        .horizontal-card {
          flex-direction: row;
          height: 618px;
        }

        .video-section {
          width: 60%;
          height: 100%;
          background: linear-gradient(135deg, #0a74da, #004a99);
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          box-shadow: inset 0 0 15px rgba(0,0,0,0.4);
          border-top-left-radius: 16px;
          border-bottom-left-radius: 16px;
          overflow: hidden;
        }

        .video-wrapper {
          width: 100%;
          height: 100%;
          position: relative;
          outline: none;
        }

        .reel-video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          cursor: pointer;
          transition: transform 0.3s ease;
          user-select: none;
          -webkit-user-drag: none;
        }

        .reel-video:hover {
          transform: scale(1.07);
        }

        .play-pause-overlay {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
          opacity: 0.8;
          transition: opacity 0.3s ease;
          user-select: none;
        }

        .play-pause-overlay.hidden {
          opacity: 0;
        }

        .no-video {
          color: white;
          font-size: 16px;
          text-align: center;
          padding: 10px 20px;
          font-weight: 600;
        }

        .card-content {
          width: 40%;
          padding: 30px 24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-top-right-radius: 16px;
          border-bottom-right-radius: 16px;
        }

        .name {
          font-size: 24px;
          font-weight: 700;
          margin: 0 0 12px;
          color: #111827;
        }

        .email {
          font-size: 15px;
          color: #6b7280;
          margin-bottom: 28px;
          word-break: break-word;
        }

        .cv-btn {
          display: inline-flex;
          align-items: center;
          background-color: #2563eb;
          color: white;
          padding: 12px 18px;
          border-radius: 10px;
          font-weight: 600;
          font-size: 15px;
          text-decoration: none;
          transition: background-color 0.25s ease, box-shadow 0.25s ease;
          box-shadow: 0 4px 10px rgba(37, 99, 235, 0.4);
          user-select: none;
        }

        .cv-btn:hover {
          background-color: #1e40af;
          box-shadow: 0 6px 18px rgba(30, 64, 175, 0.6);
        }

        .no-cv {
          color: #9ca3af;
          font-style: italic;
          font-size: 14px;
          font-weight: 500;
          user-select: none;
        }

        @media (max-width: 768px) {
          .carousel-wrapper {
            flex-direction: column;
            max-width: 100%;
            gap: 24px;
          }
          .nav-btn {
            padding: 10px;
          }
          .card {
            flex-direction: column;
            height: auto;
            border-radius: 16px;
          }
          .video-section {
            width: 100%;
            height: 360px;
            border-radius: 16px 16px 0 0;
          }
          .card-content {
            width: 100%;
            padding: 20px 18px 30px;
            border-radius: 0 0 16px 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default HRPage;
